import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {JBMSelectOption} from "../../JBMSelect/JBMSelect.component";

@Component({
  selector: 'jbm-multi-select-options-list',
  templateUrl: './optionsList.component.html',
  styleUrls: ['./optionsList.component.scss']
})
export class JBMMultiSelectOptionsListComponent implements OnInit, OnChanges {
  @Input() id: string='';
  @Input() options: JBMSelectOption[]=[];
  @Input() required: boolean=false;
  @Input() selection: number[]=[];
  @Input() minimumSelectionLength: number=0;
  @Input() editable: boolean=true;
  @Input() open: boolean=false;
  @Input() dropUp: boolean=false;
  @Input() disabled: boolean=false;

  @Output() onSelectionChange = new EventEmitter();

  ngOnInit() {}
  ngOnChanges(_changes: SimpleChanges) {
    this.updateOptions()
  }

  toggleOption(index: number) {
    if(this.disabled) return;
    if(this.options[index].selected) {
      if(this.selection.length>this.minimumSelectionLength) {
        this.options[index].selected=false
        let selectedIndex=this.selection.indexOf(parseInt(this.options[index].key));
        this.selection.splice(selectedIndex, 1);
      }
    } else {
      this.options[index].selected=true
      this.selection.push(parseInt(this.options[index].key))
    }

    this.updateOptions()
    this.onSelectionChange.emit(this.selection);
  }
  updateOptions() {
    let disableSelection=this.minimumSelectionLength>0 && this.selection.length===this.minimumSelectionLength
    for(let option of this.options) {
      option.disabled=this.disabled
      option.selected=this.selection.indexOf(parseInt(option.key))>-1
      if(option.selected)
        option.disabled=this.disabled || disableSelection
    }
  }
  getSelected(id: number) {
    return this.selection.indexOf(id)>-1
  }

  protected readonly parseInt=parseInt;
}
